export const closeModalKeyboard = () => {
    $('.closeATB, .modal-header .close').on('keypress', function (e) {
        if (e.keyCode == 13) $(this).trigger('click');
    });
    $('body').on('keydown', function (e) {
        if ($('.modal-quickview').is(':visible') && e.keyCode == 27) {
            $('.modal-quickview .close').trigger('click');
        }
    });
}